// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"16":"6981e8cb","472":"0376b742","977":"0376b742"}[chunkId] + ".chunk.css";
};